import { Button, InputAdornment } from "@mui/material";
import React from "react";

export const FastTrackAddressButton = (props) => (
  <Button
    variant="outlined"
    sx={{
      margin: "10px 0",
      borderRadius: 2,
      fontFamily: '"proxima-nova", "sans-serif"',
      maxWidth: 420,
      textTransform: "none",
      border: "1px solid rgba(255, 255, 255, 0.7)",
      width: "100%",
      height: "40px",
      color: "rgba(255, 255, 255, 0.7)",
      "&:hover": {
        border: "1px solid #ffffff",
        color: "white",
      },
      "& .MuiButton-startIcon": {
        color: "rgba(255, 255, 255, 0.7)",
      },
      "&:hover .MuiButton-startIcon": {
        color: "white",
      },
    }}
    onClick={props.onClick}
    startIcon={
      <InputAdornment className="address-icon-wrapper" position="start">
        <img className="address-icon" src="/img/svg_icons/location.svg" />
      </InputAdornment>
    }
  >
    <span className="address-button-label">
      {props.placeholder}
    </span>
  </Button>
);
